import PATH from '../constants/path.const';

const RETURN_URL_PARAM = 'returnUrl';
const AUTH_PATHS = Object.values(PATH.AUTH);

/**
 * Returns `value` only if it is a same-origin, in-app path we can safely
 * navigate to; otherwise `null`. Blocks absolute URLs, protocol-relative
 * (`//evil.com`), backslash tricks, and auth pages (which would loop).
 */
export const getSafeReturnUrl = (value) => {
  if (typeof value !== 'string' || !value.startsWith('/')) return null;
  if (value.startsWith('//') || value.includes('\\')) return null;
  try {
    const url = new URL(value, window.location.origin);
    if (url.origin !== window.location.origin) return null;
    if (AUTH_PATHS.includes(url.pathname)) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch (error) {
    return null;
  }
};

export const buildLoginUrl = (target) => {
  const safe = getSafeReturnUrl(target);
  if (!safe) return PATH.AUTH.LOGIN;
  return `${PATH.AUTH.LOGIN}?${RETURN_URL_PARAM}=${encodeURIComponent(safe)}`;
};

/** Reads and validates the `returnUrl` query param from a `location.search` string. */
export const readReturnUrl = (search) =>
  getSafeReturnUrl(new URLSearchParams(search).get(RETURN_URL_PARAM));

/**
 * The page to remember when a location is about to be sent to login. On a login
 * page that is the `returnUrl` it already carries (so a reload doesn't strip it);
 * elsewhere it is the current path itself.
 */
export const getReturnTarget = ({ pathname, search }) => {
  if (AUTH_PATHS.includes(pathname)) return readReturnUrl(search);
  return `${pathname}${search}`;
};
